var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "A",
    height: 12.7,
    width: 11.5,
    y: 0.1,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.8V.1H0v12.7z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "B",
    height: 12.9,
    width: 10.6,
    y: 0.2,
    x: 0.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7.2H.1V13h10.6z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "C",
    height: 12.9,
    width: 12.7,
    y: 0.2,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8.2H0V13h12.8z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "D",
    height: 69,
    width: 64.6,
    y: 0,
    x: 0.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.1 69h64.7V0H.1z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("filter", {
    height: 12.7,
    width: 11.5,
    y: 0.1,
    x: 0,
    filterUnits: "userSpaceOnUse",
    id: "E"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    height: 12.9,
    width: 10.6,
    y: 0.2,
    x: 0.1,
    filterUnits: "userSpaceOnUse",
    id: "F"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    height: 12.9,
    width: 12.7,
    y: 0.2,
    x: 0,
    filterUnits: "userSpaceOnUse",
    id: "G"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    height: 69,
    width: 64.6,
    y: 0,
    x: 0.1,
    filterUnits: "userSpaceOnUse",
    id: "H"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.308)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#5c2d90"
  }, /*#__PURE__*/React.createElement("path", {
    mask: "url(#D)",
    d: "M60.3 36.4L62 58.1l-30.1 5.4-2.6-21.7 4.3-.6c.7.3 1.2.4 2 .6 1.3.3 2.8.7 5-.5.5-.3 1.6-1.2 2-1.8zM13.8 62.2c-.5-.8-1.4-1.7-2.8-2.8-2-1.6-1.3-4.4-.1-6.1 1.5-2.9 9.4-6.7 9-11.4-.2-1.7-.4-3.9-2-5.5a4.15 4.15 0 0 0 0 1.2s-.7-.8-1-2c-.3-.4-.6-.6-.9-1.2-.2.7-.2 1.4-.2 1.4s-.5-1.3-.6-2.3c-.3.5-.4 1.4-.4 1.4s-.7-2-.5-3.1c-.3-.9-1.3-2.8-1-7 1.7 1.2 5.5.9 7-1.3.5-.7.8-2.7-.2-6.6-.7-2.5-2.4-6.2-3.1-7.6l-.1.1c.4 1.1 1.1 3.5 1.4 4.7.8 3.5 1.1 4.7.7 6.3-.3 1.4-1.1 2.3-3.2 3.3-2 1-4.8-1.5-4.9-1.6-2-1.6-3.5-4.2-3.7-5.4-.2-1.4.8-2.2 1.3-3.3-.7.2-1.5.6-1.5.6s.9-1 2.1-1.8c.5-.3.8-.5 1.3-.9H9.1s1.2-.7 2.5-1.1H9.8l4.8-2.1c1.5-.6 2.9-.4 3.7.7 1.1 1.5 2.2 2.3 4.5 2.9 1.4-.6 1.9-1 3.7-1.5 1.6-1.8 2.9-2 2.9-2s-.9.8-1 1.7c.9-.7 1.9-1.3 1.9-1.3s-.4.5-.7 1.2l.1.1c1.1-.6 2.3-1.1 2.3-1.1s-.4.4-.8 1c.8 0 2.4 0 3 .1 3.7.1 4.5-3.9 5.9-4.5 1.8-.6 2.6-1 5.6 2 2.6 2.6 4.6 7.1 3.6 8.1-.8.8-2.5-.3-4.4-2.6-1-1.2-1.7-2.7-2.1-4.5-.2-1.5-1.3-2.4-1.3-2.4s.7 1.5.7 2.8c0 .7.1 3.3 1.2 4.8-.1.2-.2 1.1-.3 1.2-1.3-1.6-4.2-2.7-4.6-3.1 1.6 1.3 5.2 4.2 6.6 7 1.3 2.7.5 5.1 1.2 5.7.2.2 2.8 3.4 3.3 5.1.9 2.9.1 5.9-1.1 7.7l-3.2.5c-.5-.1-.8-.2-1.2-.4.2-.4.7-1.4.7-1.6l-.2-.3c-1 1.4-2.7 2.8-4.1 3.6-1.8 1-3.9.9-5.3.4-3.9-1.2-7.6-3.8-8.4-4.5 0 0 0 .5.1.7 1 1.1 3.2 3.1 5.4 4.5l-4.6.5 2.2 17c-1 .1-1.1.2-2.2.4-.9-3.3-2.7-5.4-4.7-6.7-1.7-1.1-4.1-1.4-6.4-.9l-.1.2c1.6-.2 3.5.1 5.4 1.3s3.4 4.3 4 6.1c.7 2.4 1.2 4.9-.7 7.6-1.4 1.9-5.4 3-8.6.7.9 1.4 2 2.5 3.6 2.7 2.3.3 4.5-.1 6.1-1.6 1.3-1.3 2-4.1 1.8-7.1l2.1-.3.7 5.3L65 61.2 62 34l-1.7.3L56.9 0 .1 6.6l7 56.6z",
    transform: "matrix(.504781 0 0 .504781 4.302425 12.561819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 28.942c.757.555 1.413.9 2.07.858.404-.05.808-.707 1.06-1.312.202-.404.202-.858-.1-1-.15-.05-.757-.05-1.2 0-.858.1-1.716.404-1.918.555-.303.202-.15.707.1.9m.2-5.916v.05l.05.1c.202.404.404.808.808 1 .1 0 .202-.05.303-.05a2.09 2.09 0 0 1 .707.101v-.303c-.05-.505.1-1.413-.9-1.918-.404-.202-.9-.1-1.1.1h.1c.252.1.1.202.05.303-.05.202-.1.252 0 .606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.568 23.137c.252-.202-1.16-.505-2.272.202-.808.555-.808 1.716-.05 2.372.1.05.15.1.202.15.202-.1.505-.202.757-.303.505-.15.9-.252 1.262-.303.15-.202.353-.505.303-1.06-.05-.757-.656-.606-.202-1.06m11.106 14.187l-2.877-1.918-2.423 4.038-2.827-.858-2.473 3.786.1 1.2 13.528-2.473-.808-8.43z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.88832 0 0 .88832 40.338983 -17.07752)",
    fill: "#5c2d90"
  }, /*#__PURE__*/React.createElement("path", {
    mask: "url(#C)",
    d: "M6.4 11c-2.6 0-4-1.5-4-4.4s1.3-4.4 4-4.4c2.6 0 3.9 1.5 3.9 4.4S9 11 6.4 11M6.4.2C2.2.2 0 2.3 0 6.6.2 10.9 2.4 13 6.4 13c4.2 0 6.3-2.1 6.3-6.4.1-4.3-2-6.4-6.3-6.4",
    transform: "translate(60.382 46.346)"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#B)",
    d: "M7.1 2.2c1.3 0 2.5.2 3.6.7V.8C9.6.4 8.4.2 7 .2 2.4.2.1 2.3.1 6.5c0 4.4 2.3 6.6 6.8 6.6 1.6 0 2.8-.2 3.9-.7V5.7H6.9l-.8 2.1h2.3v3c-.5.1-1 .2-1.5.2C4 11 2.5 9.5 2.5 6.4c0-2.8 1.6-4.2 4.6-4.2",
    transform: "translate(74.67 46.346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 57.2h-2.8v-8.6h2.8c2.6 0 4 1.3 4 4-.1 3.1-1.4 4.6-4 4.6m.3-10.6h-5.5v12.7h5.5c4 0 6-2.2 6-6.7 0-4-2-6-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#A)",
    d: "M5.2 10.7H2.4V2.1h2.8c2.7 0 4 1.3 4 4 0 3.1-1.4 4.6-4 4.6M5.5.1H0v12.7h5.5c4 0 6-2.2 6-6.7 0-4-2-6-6-6",
    transform: "translate(0 46.515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6 55.8l1.6 3.5h2.5l-5.5-12.7h-2.6l-5.4 12.7h2.4L38.9 49l2 4.8h-2.6l-.8 2zm-20.7 0l1.6 3.5h2.6l-5.6-12.7H17l-5.4 12.7H14L18.2 49l2.1 4.8h-2.7l-.8 2zm2.8-7.2h3.7v10.7h2.4V48.6h3.6v-2h-9.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner10);
export default __webpack_public_path__ + "static/media/partner_10.1323cfa89aa335e7156f5c25c7b5af81.svg";
export { ForwardRef as ReactComponent };